.group {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  font-family: var(--font-mono), ui-monospace, SFMono-Regular, Menlo, monospace;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 28px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--text-muted);
  background: transparent;
  border: 0;
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition: color var(--dur-base), background var(--dur-base);
}

.btn:hover {
  color: var(--text);
}

.btn[data-active='true'] {
  color: var(--accent-contrast);
  background: var(--accent);
}

.btn:focus-visible {
  outline: none;
  box-shadow: var(--ring);
}
